import { AxiosStatic } from 'axios';

export default class UserService {
    axios;
    constructor(axios: AxiosStatic) {
        this.axios = axios;
    }

    async getUserInfo() {
        const user = await this.axios.get('users/current');

        return user.data;
    }
}
